"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisualEffect = exports.CombatEffect = void 0;
var CombatEffect;
(function (CombatEffect) {
    CombatEffect["BlockMiss"] = "block-miss";
    CombatEffect["BlockArmor"] = "block-armor";
    CombatEffect["BlockWeapon"] = "block-weapon";
    CombatEffect["BlockShield"] = "block-shield";
    CombatEffect["BlockOffhand"] = "block-offhand";
    CombatEffect["HitWeak"] = "hit-min";
    CombatEffect["HitNormal"] = "hit-mid";
    CombatEffect["HitStrong"] = "hit-max";
    CombatEffect["HitHeal"] = "hit-heal";
    CombatEffect["HitMagic"] = "hit-magic";
})(CombatEffect || (exports.CombatEffect = CombatEffect = {}));
var VisualEffect;
(function (VisualEffect) {
    VisualEffect[VisualEffect["FireFloor"] = 0] = "FireFloor";
    VisualEffect[VisualEffect["IceMist"] = 1] = "IceMist";
    VisualEffect[VisualEffect["WaterPool"] = 2] = "WaterPool";
    VisualEffect[VisualEffect["FireMist"] = 3] = "FireMist";
    VisualEffect[VisualEffect["DustMist"] = 4] = "DustMist";
    VisualEffect[VisualEffect["SnowFloor"] = 5] = "SnowFloor";
    VisualEffect[VisualEffect["IceStorm"] = 6] = "IceStorm";
    VisualEffect[VisualEffect["SludgeFloor"] = 7] = "SludgeFloor";
    VisualEffect[VisualEffect["HeatMistFull"] = 8] = "HeatMistFull";
    VisualEffect[VisualEffect["GrayMistFull"] = 9] = "GrayMistFull";
    VisualEffect[VisualEffect["FrostMistFull"] = 10] = "FrostMistFull";
    VisualEffect[VisualEffect["DullMistFull"] = 11] = "DullMistFull";
    VisualEffect[VisualEffect["HolyMistFull"] = 12] = "HolyMistFull";
    VisualEffect[VisualEffect["BlueMistFull"] = 13] = "BlueMistFull";
    VisualEffect[VisualEffect["GreenMistFull"] = 14] = "GreenMistFull";
})(VisualEffect || (exports.VisualEffect = VisualEffect = {}));
